/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * フリー形式スカウトに関するフラグ
 * @export
 * @interface GetAccount200ResponseFeatureFlagsScoutFree
 */
export interface GetAccount200ResponseFeatureFlagsScoutFree {
    /**
     * 利用可否 true:利用可 false:利用不可
     * @type {boolean}
     * @memberof GetAccount200ResponseFeatureFlagsScoutFree
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetAccount200ResponseFeatureFlagsScoutFree interface.
 */
export function instanceOfGetAccount200ResponseFeatureFlagsScoutFree(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function GetAccount200ResponseFeatureFlagsScoutFreeFromJSON(json: any): GetAccount200ResponseFeatureFlagsScoutFree {
    return GetAccount200ResponseFeatureFlagsScoutFreeFromJSONTyped(json, false);
}

export function GetAccount200ResponseFeatureFlagsScoutFreeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseFeatureFlagsScoutFree {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function GetAccount200ResponseFeatureFlagsScoutFreeToJSON(value?: GetAccount200ResponseFeatureFlagsScoutFree | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

